import React from 'react'
import { Route } from 'react-router-dom'
import CredentialsManagement from '../../../../views/Dashboard/Management/CredentialsManagement'

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <div>
    <Route path={match.path} component={CredentialsManagement} />
  </div>
)
